<div class="product-list-pagination" *ngIf="(totalResults$ | async) > 0">
    <div class="product-list-pagination__toolbar">
        <div class="product-list-pagination__per-page-row">
            <span class="text-gray-500 font-medium">Show:</span>
            <div class="relative group">
                <select
                    class="product-list-pagination__select"
                    aria-label="Items per page"
                    [ngModel]="perPage$ | async"
                    (ngModelChange)="perPageChange.emit($event)"
                >
                    <option *ngFor="let option of [5, 10, 25, 50, 100]" [value]="option">{{ option }}</option>
                </select>
            </div>
            <span class="text-gray-500 font-medium whitespace-nowrap">per page</span>
        </div>

        <div *ngIf="totalPages$ | async as totalPages" class="product-list-pagination__page-info">
            Page <span class="text-gray-900">{{ currentPage$ | async }}</span> of <span class="text-gray-900">{{ totalPages }}</span>
            <span class="ml-1 text-gray-500">({{ totalResults$ | async | number }} total results)</span>
        </div>
    </div>

    <div class="flex justify-center">
        <div class="flex items-center gap-2">
            <button
                (click)="goToFirst.emit()"
                [disabled]="(canGoPrevious$ | async) === false"
                class="product-list__pag-btn"
                aria-label="First Page"
                title="First Page"
            >
                <img src="assets/icons/chevrons-left.svg" alt="" class="w-4 h-4" />
                <span class="hidden md:inline ml-1.5">First</span>
            </button>
            <button
                (click)="goToPrevious.emit()"
                [disabled]="(canGoPrevious$ | async) === false"
                class="product-list__pag-btn"
                aria-label="Previous Page"
                title="Previous Page"
            >
                <img src="assets/icons/chevron-left-outline.svg" alt="" class="w-4 h-4" />
                <span class="hidden md:inline ml-1.5">Previous</span>
            </button>

            <div class="product-list-pagination__page-list">
                <ng-container *ngFor="let page of pageNumbers$ | async">
                    <button
                        (click)="goToPage.emit(page)"
                        class="product-list-pagination__page-btn"
                        [class.product-list-pagination__page-btn--current]="(currentPage$ | async) === page"
                        [attr.aria-label]="'Go to page ' + page"
                    >
                        {{ page }}
                    </button>
                </ng-container>
            </div>

            <button
                (click)="goToNext.emit()"
                [disabled]="(canGoNext$ | async) === false"
                class="product-list__pag-btn"
                aria-label="Next Page"
                title="Next Page"
            >
                <span class="hidden md:inline mr-1.5">Next</span>
                <img src="assets/icons/chevron-right-outline.svg" alt="" class="w-4 h-4" />
            </button>
            <button
                (click)="goToLast.emit()"
                [disabled]="(canGoNext$ | async) === false"
                class="product-list__pag-btn"
                aria-label="Last Page"
                title="Last Page"
            >
                <span class="hidden md:inline mr-1.5">Last</span>
                <img src="assets/icons/chevrons-right.svg" alt="" class="w-4 h-4" />
            </button>
        </div>
    </div>
</div>
